module.exports = __webpack_public_path__ + "static/img/10@2x.c7235a72.png";